export class MPAResourceSelector {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceSelectionMode",
            "baseName": "resourceSelectionMode",
            "type": "ResourceSelectorMode",
            "format": ""
        },
        {
            "name": "resourceInclusionOverride",
            "baseName": "resourceInclusionOverride",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceExclusionOverride",
            "baseName": "resourceExclusionOverride",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "expression",
            "baseName": "expression",
            "type": "MPAPolicyExpression",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAResourceSelector.attributeTypeMap;
    }
    constructor() {
    }
}
